export const noderedInstances: { id: number; name: string; domainName: string; }[] = [
  { id: 1, name: 'Low Code 1', domainName: `fc1.fc.apps.connexin.co.uk`, },
]